export default __webpack_public_path__ + "ae1b454323f2646cc1a140fbde647897.woff2";